<template>
  <div>
    <div class='wrapHeader'>
      <el-form :inline="true" :model="checkMac" class="demo-form-inline">
        <el-form-item label="设备名称">
          <el-input v-model="checkMac.serName" placeholder="输入设备名称" clearable @change='query'></el-input>
        </el-form-item>
        <el-form-item label="设备识别码">
          <el-input v-model="checkMac.simId" placeholder="输入设备识别码" clearable @change='query'></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div :style="`height:${height}px`" class='setBgImg'>
      <div class='showView' :style="`height:${height-20}px;width:${width-30}px`">
        <el-button type="primary" class='commonBtn addMac' icon='el-icon-circle-plus-outline' @click="addMacInfo('macInfo')">添加设备</el-button>
        <div class='setMacView' :style="`height:${height-100}px;width:${width-60}px`">
          <div class='macList' :style="`height:${height-155}px`">
            <div class='commonItem macItem' v-for='item in macList' :key='item.serId'>
              <div class='setTips'>4G</div>
              <div :class='macImage'></div>
              <div class='macName'>{{item.serName}}</div>
              <div class='relevanceWareName' v-if='macType=="DEVYQSYS"||macType=="DEVAIRCOND"||macType=="DEVWHZSK4G"'>关联仓房：{{item.wareNameVoList.length>0?item.wareNameVoList[0].wareName:''}}</div>
              <div class='btnList'>
                <el-row>
                  <el-button type="primary" icon="el-icon-edit" circle class='setOilBtn' @click='editMacInfo(item.serId)'></el-button>
                  <el-button type="danger" icon="el-icon-delete" circle class='setOilBtn' @click='deleteMac(item.serId)'></el-button>
                </el-row>
              </div>
            </div>
          </div>
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total" 
            :pageSize='checkMac.pageSize'
            :hide-on-single-page='true'
            :current-page='checkMac.pageNum'
            @current-change='pageChange'
            class='setPosition'>
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="设备基本信息" :visible.sync="showMacInfo"
      :close-on-click-modal='false'
      :custom-class='"dialog-setBg dialog-setMac-bg"'>
      <div class='formWrap'>
        <el-form ref="macInfo" :model="macInfo" label-width="100px" :rules='saveMacRules'>
          <div class='dialog-setWrap dialog-setMac-wrap'>
            <el-form-item label="设备名称" prop='serName'>
              <el-input v-model="macInfo.serName"></el-input>
            </el-form-item>
            <el-form-item label="设备识别码" prop='simId'>
              <el-input v-model="macInfo.simId"></el-input>
            </el-form-item>
            <el-form-item label="关联仓房" prop='wareId' v-if='macType=="DEVAIRCOND"||macType=="DEVGASSYS"||macType=="DEVWHZSK4G"'>
              <el-select v-model="macInfo.wareId" placeholder="请选择关联仓房">
                <el-option :label="ware.wareName" :value='ware.wareId' v-for='ware in wareList' :key='ware.wareId'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备功率" prop='power' v-if='macType=="DEVYQSYS"||macType=="DEVAIRCOND"||macType=="DEVGASSYS"'>
              <el-input v-model="macInfo.power" placeholder="请输入数字"><i slot="suffix" style="font-style:normal;margin-right:5x;font-size:14px">KW</i></el-input>
            </el-form-item>
            <el-form-item label="设备类型">
              <el-input :value='setMacTypeName' readonly></el-input>
            </el-form-item>
            <el-form-item label="分组数" prop='group' v-if='macType=="DEVYQSYS"'>
              <el-select v-model="macInfo.group" placeholder="请选择分组数" @change='setGroupInfo'>
                <el-option :label="item" :value='item' v-for='item in groupList' :key='item'></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if='macInfo.group&&macType=="DEVYQSYS"'>
            <div class='baseInfoTitle' style="padding-top:10px"><span></span>分组使用信息</div>
            <div class='dialog-setWrap dialog-setWrap-grainMac'>
              <el-form-item :label="`第 ${index+1} 组`" v-for='(item,index) in groupInfoList' :key='index'>
                <el-select 
                  clearable 
                  v-model="item.wareId" 
                  placeholder="请选择使用该组的仓房" 
                  @change='((val)=>{setWareHouseList(val,index)})'>
                  <el-option 
                    :label="ware.wareName" 
                    :value='ware.wareId'
                    v-for='ware in wareList'
                    :disabled="ware.disabled" 
                    :key='ware.wareId' 
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <el-form-item class='saveBtn'>
            <el-button type="primary" @click="saveMacInfo('macInfo')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  props:{
    width:Number,
    height:Number,
    macType:String
  },
  data(){
    const checkNum=(rule, val, callback) => {
      let value=val.toString()
      if(rule.field=='power'){
        if(value.indexOf(".")!=-1&&(value.split('.').length>2||value.split('.')[0]===''||value.split('.')[1]==='')){
          callback(new Error('请输入正确格式的数字'))
        }else if(value.indexOf('.')!=-1&&value.split('.')[1].length>2){
          callback(new Error('最多输入两位小数'))
        }else{
          callback()
        }
      }
    }
    return{
      checkMac:{
        pageNum:1,
        pageSize:15,
        orderByColumn:'serId',
        serType:this.macType,
        isAsc:'desc',
        serName:'',
        simId:'',
      },
      macList:[],
      total:0,
      showMacInfo:false,
      loading:false,
      groupList:[1,2,4,8],
      groupInfoList:[],
      saveMacRules:{
        serName:[
          {trigger:'blur',message:'设备名称不能为空',required:true}
        ],
        simId:[
          {trigger:'blur',message:'设备识别码不能为空',required:true}
        ],
        wareId:[
          {trigger:'change',message:'请选择关联仓房',required:true}
        ],
        power:[
          {trigger:'blur',message:'设备功率不能为空',required:true},
          {trigger:'blur',validator:checkNum}
        ]
      },
      macInfo:{},
      wareList:[],
      isAdd:false
    }
  },
  created(){
    this.getWareList()
    this.getMacList()
  },
  computed:{
    setMacTypeName(){
      let name=this.macType=='DEVNHLSYS'?'内环流控制器':(this.macType=='DEVYQSYS'?'油情控制器':(this.macType=='DEVAIRCOND'?'4G空调机':(this.macType=='DEVGASSYS'?'气体检测控制器':(this.macType=='DEVWHZSK4G'?'多功能控制器':''))))
      return name
    },
    macImage(){
      let macImage=this.macType=='DEVNHLSYS'||this.macType=='DEVYQSYS'||this.macType=='DEVGASSYS'||this.macType=='DEVWHZSK4G'?"setOilImg":(this.macType=='DEVAIRCOND'?'setAirImg':'')
      return macImage
    }
  },
  methods:{
    setWareHouseList(val,index){
      if(val==''){
        this.wareList.forEach(item=>{
          if(item.wareName==this.groupInfoList[index].wareName){
            item.disabled=false
          }
        })
      }else{
        this.wareList.forEach(item=>{
          if(item.wareId==val){
            item.disabled=true;
            this.groupInfoList[index].wareName=item.wareName
          }
        })
      }
    },
    setGroupInfo(num){
      this.groupInfoList=this.setGroupList(num);
      this.$forceUpdate();
    },
    setGroupList(num){
      let arr=[];
      for(let i=0;i<num;i++){
        arr.push({useGroup:i+1})
        if(this.macInfo.wareHouseList){
          this.macInfo.wareHouseList.forEach(item=>{
            if(item.useGroup==i+1){
              arr.fill(item,i,i+1)
            }
          })
        }
      }
      return arr;
    },
    query(){
      this.checkMac.pageNum=1;
      this.getMacList();
    },
    getMacList(){
      axios.get('/system/ser/list',{params:this.checkMac}).then(res=>{
        if(res){
          this.total=res.total;
          this.macList=res.rows;

        }
      })
    },
    getWareList(){
      let type=0
      if(this.macType=='DEVYQSYS'){
        type=1
      }else{
        type=0
      }
      axios.get('/system/house/getHouseSelect',{params:{type:type}}).then(res=>{
        if(res){
          if(type==1){
            let data=res.data;
            data.forEach(item=>{
              if(item.isCheck==1){
                item.disabled=true;
              }
            })
            this.wareList=data;
          }else{
            this.wareList=res.data;
          }
        }
      })
    },
    addMacInfo(){
      this.showMacInfo=true;
      if(this.isAdd){
        this.$refs.macInfo.resetFields();
      }
      this.isAdd=true
    },
    // 设置加载动画
    setAirLoading(){
      this.loading=this.$loading({
        text:'请稍等',
        target:document.querySelector('.dialog-setAir-bg')
      })
    },
    editMacInfo(serId){
       this.showMacInfo=true;
      axios.get(`/system/ser/${serId}`).then(res=>{
        if(res){
          this.macInfo=res.data;
          this.isAdd=false;
          this.setGroupInfo(res.data.group)
        }
      })
    },
    deleteMac(serId){
      this.$confirm('此操作将永久删除该设备, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.delete(`/system/ser/delete/${serId}`).then(data=>{
          if(data){
            this.getMacList()
            this.$message({
              type: 'success',
              message: '删除成功!',
              duration:1000
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          duration:1000
        });          
      });
    },
    saveMacInfo(formName){
      this.$refs[formName].validate(valid=>{
        if(valid){
          let macInfo=this.macInfo;
          macInfo.serType=this.macType;
          this.setAirLoading()
          if(this.isAdd){
            if(this.macType=="DEVYQSYS"){
              let arr=[]
              this.groupInfoList.forEach(item=>{
                if(item.wareId){
                  arr.push(item)
                }
              })
              macInfo.wareHouseList=arr;
              axios.post('/system/ser',macInfo).then(res=>{
                if(res){
                  axios.post('/system/ser/saveConfig',{serId:res.serId}).then(res=>{
                    this.loading.close();
                    this.showMacInfo=false
                    this.getMacList();
                    if(res){
                      this.$message({
                        type: 'success',
                        message: '添加成功!',
                        duration:1000
                      });
                    }
                  })
                }else{
                  this.loading.close();
                }
              })
            }else{
              axios.post('/system/ser',macInfo).then(res=>{
                this.loading.close();
                if(res){
                  this.getMacList();
                  this.$message({
                    type: 'success',
                    message: '添加成功!',
                    duration:1000
                  });
                  this.showMacInfo=false
                }
              })
            }
          }else{
            if(this.macType=="DEVYQSYS"){
              let arr=[]
              this.groupInfoList.forEach(item=>{
                if(item.wareId){
                  arr.push(item)
                }
              })
              macInfo.wareHouseList=arr;
              axios.put('/system/ser',macInfo).then(res=>{
                if(res){
                  axios.post('/system/ser/saveConfig',{serId:macInfo.serId}).then(res=>{
                    this.loading.close();
                    this.showMacInfo=false
                    this.getMacList();
                    if(res){
                      this.$message({
                        type: 'success',
                        message: '添加成功!',
                        duration:1000
                      });
                    }
                  })
                }else{
                  this.loading.close();
                }
              })
            }else{
              axios.put('/system/ser',macInfo).then(res=>{
                this.loading.close();
                if(res){
                  this.getMacList();
                  this.$message({
                    type: 'success',
                    message: '修改成功!',
                    duration:1000
                  });
                  this.showMacInfo=false
                }
              })
            }
          }
        }else{
          return false
        }
      })
    },
    pageChange(val){
      this.checkMac.pageNum=val;
      this.checkMac.serName='';
      this.checkMac.simId='';
      this.getMacList()
    }
  }
}
</script>

<style>
  .addMac{
    left: 15px;
  }
  .macList{
    border: 1px solid #e4e7ed;
    padding-left: 8px;
    padding-top: 8px;
    box-sizing: border-box;
    overflow: auto
  }
  .macItem{
    margin: 10px 10px 8px 8px;
    width: 300px;
    height: 219px;
  }
  .dialog-setMac-bg{
    width: 740px !important
  }
  .dialog-setMac-wrap{
    width: 700px;
    flex-wrap:wrap
  }
  .dialog-setMac-wrap .el-form-item{
    width: 50%
  }
  .setOilImg{
    width:127.2px;
    height:99.6px;
    background-image: url('../../assets/oil/oilMac.png');
    background-size: cover
  }
  .setAirImg{
    width: 146.4px;
    height:99px;
    background-image: url('../../assets/air/air.png');
    background-size: cover
  }
  .macName{
    font-size: 16px;
    font-weight: 600;
  }
  .relevanceWareName{
    font-size: 12px;
    font-weight: 600;
    color: rgba(0,0,0,0.35);
    position: absolute;
    left: 10px;
    bottom: 10px;
    height: 24px;
    line-height: 24px;
  }
  .btnList{
    position: absolute;
    bottom: 10px;
    right:10px;
  }
  .setOilBtn{
    margin: 2px !important;
    padding: 5px !important
  }
</style>